(function () {
    'use strict';
    angular.module('Services').service('AccountingAffiliateTable', AccountingAffiliateTable);
    AccountingAffiliateTable.$inject = [
        'TableLiteFactory',
        '$filter',
        '$uibModal'
    ];

    function AccountingAffiliateTable(
        TableLiteFactory,
        $filter,
        $uibModal
    ) {
        return function (affiliateCommission, isViewMode, currency, addSurchargeCallback) {
            function showAddSurchargeModal() {
                const modal = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/accounting/modals/add-new-surcharge-modal.html',
                    controller: 'AddNewSurchargeModalController',
                    controllerAs: 'vm',
                    windowClass: 'full-height-modal',
                    size: 'md',
                    appendTo: $('body'),
                });

                modal.result.then(data => {
                    const addedSurcharge = {
                        name: data.surchargeType.surchargeInternalName,
                        fix: data.fix,
                        percent: data.percent
                    };
                    tableData.data.push(generateRowData(addedSurcharge));

                    addSurchargeCallback();
                });
            }

            const tableData = {
                optionAddOns: {
                },
                config: {
                    tableMinHeight: '200px',
                    noPagination: true,
                    noHeaders: false,
                    noItemView: true,
                    noFooter: true
                },
                headers: [{
                    label: 'Sub Affiliates',
                    viewName: 'affiliates',
                    fieldName: 'affiliates'
                }, {
                    label: 'Commission Value',
                    width: '150px', 
                    viewName: 'fixedValue',
                    fieldName: 'fixedValue'
                }, {
                    label: 'Commission %',
                    width: '150px',
                    viewName: 'percentage',
                    fieldName: 'percentage'
                }, {
                    label: 'Commission % VALUE',
                    viewName: 'commissionPercentValue',
                    fieldName: 'commissionPercentValue'
                },{
                    label: 'Affiliate Commission',
                    viewName: 'totalCommission',
                    fieldName: 'totalCommission'
                }],
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: function (callback) {
                    console.log(affiliateCommission)
                    callback({ content: affiliateCommission });
                },
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: data => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });

            function buildTableData(data) {
                if (!data) {
                    return tableData;
                }
                tableActions.initializeTableData(data);

                angular.forEach(data.content, row => {
                    tableData.data.push(generateRowData(row));
                });
            }

            function generateRowData(data) {
                return {
                    fixedValue: {
                        url: '/templates/directives/intellectual-table/body-cells/unit-input.html',
                        value: data.commissionValue ,
                        valueType: 'monitary',
                        id: data.name + 'fixValue',
                        addOnLabel: currency,
                        fullWidth: true,
                        disabled: isViewMode
                    },
                    percentage: {
                        url: '/templates/directives/intellectual-table/body-cells/unit-input.html',
                        value: data.commissionPercent,
                        valueType: '',
                        id: data.name + '',
                        addOnLabel: '%',
                        fullWidth: true,
                        disabled: isViewMode
                    },
                    commissionPercentValue: {
                        url: '/templates/directives/intellectual-table/body-cells/unit-input.html',
                        value:  data.commissionPercent ? data.totalCommission.toFixed(2) : '0',
                        valueType: '',
                        id: data.name + '',
                        addOnLabel: 'AUD',
                        fullWidth: true,
                        disabled: isViewMode
                    },
                    totalCommission: {
                        url: '/templates/directives/intellectual-table/body-cells/unit-input.html',
                        value: data.totalCommission ? data.totalCommission.toFixed(2) : '0',
                        valueType: '',
                        id: data.name + '',
                        addOnLabel: 'AUD',
                        fullWidth: true,
                        disabled: isViewMode
                    },
                    affiliates: data.companyMarketingName || 'N/A'
                }
            }

            function getTotalSurcharges(sellPrice) {
                let basePrice = Number(sellPrice);
                let surchargeTotal = 0;

                let prevFixValue = 0;
                let prevPercentTotalValue = 0;
                let surchargeRunningValue = basePrice;

                tableData.data.forEach(item => {
                    const fixValue = Number(item.fixedValue.value);
                    const percent = Number(item.percentage.value);
                    surchargeTotal += fixValue;

                    if (percent > 0) {
                        surchargeRunningValue += prevFixValue + prevPercentTotalValue;
                        const percentageValue = ((surchargeRunningValue + fixValue) * percent) / 100;

                        item.percentageValue = percentageValue.toFixed(2);
                        prevFixValue = fixValue;
                        prevPercentTotalValue = percentageValue;
                        surchargeTotal += percentageValue;
                    }
                     else {
                        item.percentageValue = percent.toFixed(2);
                    }
                });

                return {
                    surchargeTotal: math.bignumber(surchargeTotal)
                };
            }

            function getSurchargesDetails() {
                return tableData.data.map(item => {
                    return {
                        fix: Number(item.fixedValue.value),
                        name: item.surchargeName,
                        percent: Number(item.percentage.value),
                        percentAmount: Number(item.percentageValue),
                        totalAmount: Number(item.fixedValue.value) + Number(item.percentageValue)
                    }
                });
            }

            this.getTotalSurcharges = getTotalSurcharges;
            this.getSurchargesDetails = getSurchargesDetails;
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/accountingTables/AccountingAffiliateTable.js